// Fetch list

export const FETCH = 'equipments.FETCH'
export const FETCH_STARTED = 'equipments.FETCH_STARTED'
export const FETCH_FULFILLED = 'equipments.FETCH_FULFILLED'
export const FETCH_REJECTED = 'equipments.FETCH_REJECTED'
export const FETCH_CANCELLED = 'equipments.FETCH_CANCELLED'

export const SORTING_CHANGED = 'equipments.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'equipments.FETCH_ONE'
export const FETCH_ONE_STARTED = 'equipments.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'equipments.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'equipments.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'equipments.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'equipments.SAVE'
export const SAVE_STARTED = 'equipments.SAVE_STARTED'
export const SAVE_FULFILLED = 'equipments.SAVE_FULFILLED'
export const SAVE_REJECTED = 'equipments.SAVE_REJECTED'
export const SAVE_CANCELLED = 'equipments.SAVE_CANCELLED'

// Delete

export const DELETE = 'equipments.DELETE'
export const DELETE_STARTED = 'equipments.DELETE_STARTED'
export const DELETE_FULFILLED = 'equipments.DELETE_FULFILLED'
export const DELETE_REJECTED = 'equipments.DELETE_REJECTED'
export const DELETE_CANCELLED = 'equipments.DELETE_CANCELLED'

// Export

export const EXPORT = 'equipments.EXPORT'
export const EXPORT_FULFILLED = 'equipments.EXPORT_FULFILLED'
